import * as Zapi from '@zattoo/zapi';
export const zapiSignIn = async (parameters) => {
    await Zapi.loginAccountV3({
        login: parameters.email,
        password: parameters.password,
    });
};
